import dayjs from 'dayjs';

export const getTimeText = (timestamp?: string) => {
  if (!timestamp) return '';

  const now = dayjs();
  const targetTime = dayjs(timestamp);
  const diffDays = now.diff(targetTime, 'day');
  const diffMinutes = now.diff(targetTime, 'minute');

  if (diffMinutes < 5) {
    return '방금 전';
  }

  if (diffDays > 365) {
    return '오래 전';
  }

  return dayjs(timestamp).fromNow();
};
